// TODO: llevar esto a DS

// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState, forwardRef } from "react";
import { IconButton, Label, Hint } from "@artprov/design-system";
import { Icon } from "@artprov/design-system";
import { cn } from "@artprov/design-system";

const Status = Object.freeze({
  SUCCESS: "success",
  ERROR: "error",
  DEFAULT: "default",
  DISABLED: "disabled",
});

// /**
//  * El componente Input permite a los usuarios ingresar texto u otros tipos de valores con opciones personalizables.
//  *
//  * @param {Object} props - El objeto de propiedades.
//  * @param {string} [props.type='text'] - El tipo de entrada, puede ser 'text', 'password', 'email', entre otros.
//  * @param {string} [props.placeholder='Placeholder'] - El texto del placeholder para el campo de entrada.
//  * @param {string} [props.info=''] - Información adicional para mostrar en la etiqueta del campo.
//  * @param {import('react').FocusEventHandler } [props.onBlur] - Función de devolución de llamada para actualizar el valor del campo de entrada.
//  * @param {import('react').FocusEventHandler } [props.onFocus] - Función de devolución de llamada para actualizar el valor del campo de entrada.
//  * @param {function} [props.setSelected] - Función de devolución de llamada para actualizar el valor del campo de entrada.
//  * @param {function} [props.onChange] - Función de devolución de llamada para actualizar el valor del campo de entrada.
//  * @param {import('react').KeyboardEventHandler<HTMLInputElement>} [props.onKeyDown] - Función de devolución de llamada para actualizar el valor del campo de entrada.
//  * @param {string} [props.selected=''] - El valor actual del campo de entrada.
//  * @param {string} [props.label=''] - El texto de la etiqueta para el campo de entrada.
//  * @param {boolean} [props.isOptional=false] - Define si el campo es opcional; si es verdadero, muestra "(opcional)" con un ícono de información.
//  * @param {boolean} [props.isRequired=false] - Define si el campo es obligatorio.
//  * @param {Array<{ variant: string, text: string }>} [props.hints=[]] - Pistas que se muestran debajo del campo de entrada.
//  * @param {string} [props.value] - El valor del campo de entrada.
//  * @param {string} [props.classNameContainer=''] - El nombre de la clase para el contenedor principal del componente Input.
//  * @param {string} [props.classNameContainerInput=''] - El nombre de la clase para el contenedor del campo de entrada.
//  * @param {string} [props.className=''] - El nombre de la clase para el campo de entrada.
//  * @param {boolean} [props.disabled=false] - Define si el campo de entrada está deshabilitado.
//  * @param {string} [props.leftIcon=null] - Ýcono opcional para mostrar en el lado izquierdo del campo de entrada.
//  * @param {string} [props.rightIcon=null] - Ýcono opcional para mostrar en el lado derecho del campo de entrada.
//  * @param {function} [props.rightFunction=null] - Función que se ejecuta al hacer clic en el ícono derecho.
//  * @param { string } [props.status] - El estado del campo de entrada (éxito, error, etc.).
//  * @param {number} [props.maxCharacters=0] - Número máximo de caracteres permitidos en el campo de entrada.
//  * @param {string} [props.unit=''] - Unidad de medida para el campo de entrada.
//  * @param {boolean} [props.readOnly=false] - Define si el campo es obligatorio.
//  * @returns {JSX.Element} El componente Input renderizado.
//  */
const InputFile = forwardRef(
  (
    {
      type = "text",
      placeholder = "Placeholder",
      info = "",
      // eslint-disable-next-line no-unused-vars
      onChange = (_) => {},
      onKeyDown,
      value = "",
      label = "Label",
      isOptional = false,
      isRequired = false,
      hints = [
        {
          variant: "info",
          text: "Ingrese un valor válido",
        },
      ],
      classNameContainer = "",
      classNameContainerInput = "",
      className = "",
      disabled = false,
      leftIcon = "",
      rightIcon = "close",
      rightFunction = (_) => {},
      status = Status.DEFAULT,
      maxCharacters: maxCharecters = 0,
      unit = "",
      readOnly = false,
      ...props
    },
    ref
  ) => {
    const [internalValue, setInternalValue] = useState(value);

    const handleChange = (e) => {
      const nuevoValor = e?.target?.value;

      if (maxCharecters > 0 && nuevoValor.length > maxCharecters) return;
      setInternalValue(nuevoValor);
      onChange(nuevoValor);
    };

    const handleClearInput = () => {
      setInternalValue("");
      onChange("");
    };

    const defaultRightFunction = rightFunction ?? handleClearInput;

    const shouldShowRightIcon = !!internalValue?.length || readOnly;

    useEffect(() => {
      setInternalValue(value);
      onChange(value);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    useEffect(() => {
      if (type === "date") {
        const filteredValue = value.replace(/[^0-9/]/g, "");
        setInternalValue(filteredValue);
        onChange(filteredValue);
      }

      if (type === "number") {
        const filteredValue = value.replace(/\D/g, "");
        setInternalValue(filteredValue);
        onChange(filteredValue);
      }

      if (type === "money") {
        //currency format e.g: "1.000,55"
        const filteredValue = value.replace(/[^\d,.-]/g, "");
        setInternalValue(filteredValue);
        onChange(filteredValue);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [internalValue]);

    return (
      <Container className={classNameContainer}>
        {label && (
          <Label
            label={label}
            info={info}
            isOptional={isOptional}
            isRequired={isRequired}
            className="mt-2 mb-2"
          />
        )}

        <ContainerInput
          className={classNameContainerInput}
          disabled={disabled}
          status={status}>
          {/* Icono de la izquierda */}
          {leftIcon && (
            <Icon
              icon={leftIcon}
              className={cn(disabled ? "text-tertiary-80" : "text-primary-10")}
              size="small"
            />
          )}

          {/* <label> */}
          {/* <IconButton
              icon={"publish"}
              onClick={() => defaultRightFunction(internalValue)}
              size="small"
              className="text-primary-10 p-0 hover:bg-tertiary-100 focus:border-none"
              disabled={disabled}
              type="button"
            /> */}
          {/* </label> */}
          <input
            ref={ref}
            type={["email", "password", "file"].includes(type) ? type : "text"}
            {...(type !== "file" && {
              value: internalValue,
              onChange: handleChange,
            })}
            // value={internalValue}
            // onChange={handleChange}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            disabled={disabled}
            className={cn(
              "flex-grow ",
              "outline-none placeholder:typography-b2 placeholder:text-tertiary-80 text-tertiary-40 typography-b2 pl-2",
              className,
              disabled && "hover:cursor-not-allowed"
            )}
            style={{
              width:
                !!unit && !!internalValue.length
                  ? `${internalValue.length + 1}ch`
                  : "inherit",
            }}
            readOnly={readOnly}
            {...props}
          />
          {!!unit && !!internalValue.length && (
            <span className="text-tertiary-40 text-xs">{unit}</span>
          )}

          {/* Icono de la derecha */}
          {rightIcon && (
            <div className="flex items-center justify-center w-6">
              {shouldShowRightIcon && (
                <IconButton
                  icon={rightIcon}
                  onClick={() => defaultRightFunction(internalValue)}
                  size="small"
                  className="text-primary-10 p-0 hover:bg-tertiary-100 focus:border-none"
                  disabled={disabled}
                  type="button"
                />
              )}
            </div>
          )}
        </ContainerInput>
        {!!hints.length && (
          <div className="pt-1">
            {hints
              .map(({ variant, text }) => (
                <Hint key={text} text={text} variant={variant} />
              ))
              .filter(Boolean)}
          </div>
        )}
      </Container>
    );
  }
);
/**
 * El componente ContainerInput permite a los usuarios ingresar texto u otros tipos de valores con opciones personalizables.
 * Este componente se utiliza para encapsular el campo de entrada y personalizar su apariencia.
 *
 * @param {Object} props - El objeto de propiedades.
 * @param {React.ReactNode} props.children - Los elementos secundarios que se renderizan dentro del contenedor.
 * @param {string} [props.className=''] - El nombre de la clase para el contenedor.
 * @param {boolean} [props.disabled=false] - Define si el campo de entrada está deshabilitado.
 * @param {string } [props.status] - El estado del campo de entrada (éxito, error, etc.).
 *
 * @returns {JSX.Element} El componente ContainerInput renderizado.
 *
 */
const ContainerInput = ({
  children,
  className = "",
  disabled = false,
  status = Status.DEFAULT,
}) => {
  const borderColorClasses =
    {
      [Status.SUCCESS]: "border-success-40",
      [Status.ERROR]: "border-error-20",
      [Status.DEFAULT]: "border-tertiary-80 focus-within:border-primary-10 h-9",
      [Status.DISABLED]: "border-tertiary-80",
    }[status] ?? "border-tertiary-80";

  return (
    <div
      className={cn(
        "flex items-center border-[1.5px] rounded px-2 py-1 w-full h-9 focus-within:border-[2px]",
        borderColorClasses,
        disabled && "bg-tertiary-98 cursor-not-allowed",
        className
      )}>
      {children}
    </div>
  );
};

const Container = ({ children, className = "" }) => (
  <div className={cn("relative w-full rounded", className)}>{children}</div>
);

InputFile.Container = Container;
InputFile.ContainerInput = ContainerInput;

export { InputFile };
